"use client";
import { FC_TERMS_AND_CONDITIONS_V2 } from "@ctv/core/feature-control/constants";
import { useFeatureControl } from "@ctv/shared-core/src";

import LegacyTermsAndConditions from "./LegacyTermsAndConditions";
import TermsAndConditions from "./TermsAndConditions";

type Props = {
  verified: boolean;
};

export default function DesktopTermsAndConditions(props: Props) {
  const { enabled } = useFeatureControl(FC_TERMS_AND_CONDITIONS_V2);

  if (enabled) {
    return <TermsAndConditions {...props} />;
  }

  return <LegacyTermsAndConditions />;
}
